module.exports = __webpack_public_path__ + "media/Investor_Memorandum_Video_Final.76dfb46b.mp4";